"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketService = void 0;
/**
 * Wrapper Service extending SailsService Sockets
 */
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser"); //NOTE: On Angular >=4.x DOCUMENT is located on @angular/common
const angular2_sails_1 = require("angular2-sails");
const notifier_service_1 = require("./notifier.service");
const branding_service_1 = require("./branding.service");
let WebSocketService = class WebSocketService extends angular2_sails_1.SailsService {
    constructor(document, ngZone, _notifier, _branding) {
        super(ngZone);
        this.document = document;
        this.ngZone = ngZone;
        this._notifier = _notifier;
        this._branding = _branding;
        this.callOnSocketConnected = [];
        this.callOnSocketDisconnected = [];
        this.connection = null;
        // don't display logs on prod environemnt
        this.silent = this.getServerEnv() === "gen-prod";
    }
    connectSocket({ server = "", onConnected = null, onDisconnect = null, context = null, } = {}) {
        if (onConnected && context) {
            this.callOnSocketConnected.push({ onConnected, context });
        }
        if (onDisconnect && context) {
            this.callOnSocketDisconnected.push({ onDisconnect, context });
        }
        if (!this.connection) {
            server = server || this.getSocketDns();
            this.serverUrl = server;
            // connect server url, and subscribe to listen for connection events
            this.connection = this.connect({ url: server });
            this.connection.subscribe({
                next: (event) => {
                    if (event.connected) {
                        this.onSocketConnected();
                        this.callAllConnectObservers(event);
                    }
                    else {
                        this.onSocketDisconnect();
                        this.callAllDisconnectObservers(event);
                    }
                },
                error: (err) => {
                    console.error("WebSocket Connect event error", err);
                },
            });
        }
        // return the connection Subject so callers
        // can subcribe to it
        return this.connection;
    }
    getSocketDns(serverEnv) {
        serverEnv = serverEnv || this.getServerEnv();
        // Try to get baseURL from document data attributes
        const body = this.document.body;
        const raw = body && body.dataset.baseurl;
        let baseURLData = null;
        if (raw) {
            try {
                baseURLData = JSON.parse(raw);
            }
            catch (_) {
                /* ignore malformed JSON */
            }
        }
        if (baseURLData) {
            // Determine which product we're using based on branding
            const isBiddrConnect = this.useBiddrConnectBranding();
            const product = isBiddrConnect ? "biddrConnect" : "biddr360";
            const baseURL = baseURLData[product];
            if (baseURL) {
                try {
                    // Use URL constructor for more robust parsing
                    const parsed = new URL(baseURL, this.document.location.origin);
                    const origin = `${this.document.location.protocol}//${parsed.host}`;
                    return `${origin}/`;
                }
                catch (_) {
                    // fall through to env-based fallback
                }
            }
        }
        // Fallback to hardcoded values if config is not available
        switch (serverEnv) {
            case "development":
                return this.document.location.origin;
            case "gen-dev":
                return `${this.document.location.protocol}//biddr-360.dev.ssp.cadent.com/`;
            case "gen-staging":
                return `${this.document.location.protocol}//biddr-360.qa.ssp.cadent.com/`;
            case "gen-prod":
                return `${this.document.location.protocol}//biddr-360.ssp.cadent.com/`;
            default:
                return this.document.location.origin;
        }
    }
    useBiddrConnectBranding() {
        return this._branding.useBiddrConnectBranding();
    }
    getServerEnv() {
        let body = this.document.getElementsByTagName("body")[0];
        if (body && body.dataset.env)
            return body.dataset.env;
        return "unknown";
    }
    onSocketDisconnect() {
        this._notifier.start({
            title: "Connection Status",
            preserveType: "permanent",
            id: "socket-connection-lost",
            status: "Server Connection Lost",
            message: "Our internal services may be under temporary maintenance or your browser lost internet connectivity.",
            type: "error",
        });
    }
    onSocketConnected() {
        this._notifier.deleteNotification("socket-connection-lost", true);
    }
    callAllConnectObservers(event) {
        if (this.callOnSocketConnected.length) {
            this.callOnSocketConnected.forEach((observer) => {
                observer.onConnected.call(observer.context, event);
            });
        }
    }
    callAllDisconnectObservers(event) {
        if (this.callOnSocketDisconnected.length) {
            this.callOnSocketDisconnected.forEach((observer) => {
                observer.onDisconnect.call(observer.context, event);
            });
        }
    }
};
exports.WebSocketService = WebSocketService;
exports.WebSocketService = WebSocketService = __decorate([
    (0, core_1.Injectable)(),
    __param(0, (0, core_1.Inject)(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [Object, core_1.NgZone,
        notifier_service_1.NotifierService,
        branding_service_1.BrandingService])
], WebSocketService);
//# sourceMappingURL=websocket.service.js.map